import gql from 'graphql-tag';

export const DENY_TENDER_ASSESSMENT = gql`
  mutation DenyTenderAssessment($input: TenderAssessmentInput!) {
    denyTenderAssessment(input: $input)
  }
`;
